import { GET_GLOBAL_STATS_DATA_QUERY as STATS_QUERY } from "../../bento/globalStatsData";
import { defaultFilters } from "../../bento/dashboardTabData";
import client from "../../utils/graphqlClient";

export const RECEIVE_STATS = "RECEIVE_STATS";
export const STATS_QUERY_ERR = "STATS_QUERY_ERR";
export const READY_STATS = "READY_STATS";
export const REQUEST_STATS = "REQUEST_STATS";

export const initialState = {
  isFetched: false,
  isLoading: false,
  error: "",
  hasError: false,
  data: {},
};

function shouldFetchDataForAllStats(state) {
  return !state.stats.isFetched;
}

function readyStats() {
  return {
    type: READY_STATS,
  };
}

function receiveStats(json) {
  const mainData = json?.data?.searchParticipants || {};

  // Override file counts with association-filtered queries for accurate counts
  // This ensures Files tab shows biospecimen/participant files and Study Files tab shows study files
  const statsData = {
    ...mainData,
    numberOfFiles:
      json?.data?.filesTabCount?.numberOfFiles ?? mainData.numberOfFiles,
    numberOfStudyFiles:
      json?.data?.studyFilesTabCount?.numberOfStudyFiles ??
      mainData.numberOfStudyFiles,
  };

  return {
    type: RECEIVE_STATS,
    payload: {
      data: statsData,
    },
  };
}

function errorhandler(error, type) {
  return {
    type,
    error,
  };
}

function fetchStats(statQuery) {
  return (dispatch) => {
    dispatch({ type: REQUEST_STATS });
    return client
      .query({
        query: statQuery,
        // Using default cache-first policy for efficient caching
        variables: {
          // Include association filters for accurate file counts
          files_association: defaultFilters.files.association,
          study_association: defaultFilters.studyFiles.association,
        },
      })
      .then((result) => dispatch(receiveStats(result)))
      .catch((error) => dispatch(errorhandler(error, STATS_QUERY_ERR)));
  };
}

export function fetchDataForStats(options = {}) {
  const { force = false } = options;

  return (dispatch, getState) => {
    if (force || shouldFetchDataForAllStats(getState())) {
      return dispatch(fetchStats(STATS_QUERY));
    }
    return dispatch(readyStats());
  };
}

export default function dashboardReducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_STATS:
      return {
        ...state,
        hasError: false,
        isLoading: false,
        isFetched: true,
        data: action.payload.data,
      };
    case STATS_QUERY_ERR:
      return {
        ...state,
        hasError: true,
        error: action.error,
        isLoading: false,
        isFetched: true,
      };
    case READY_STATS:
      return {
        ...state,
        isLoading: false,
        isFetched: true,
      };
    case REQUEST_STATS:
      return {
        ...state,
        isLoading: true,
        data: {},
      };
    default:
      return state;
  }
}
